export class PipelineStrings {
  static introTitle = 'Move your data from any Source to a Destination in near real-time';

  static introDescription =
    'Get data in your Destinations in near real-time and easily track data loading progress.';

  static restartObjectConfirmationMessage =
    'If you proceed, the existing data in your Destination table will be deleted and replaced entirely with new data.';

  static disablePipelineSuccessMessage =
    'Request to disable Pipeline has been successfully registered.';

  static enablePipelineSuccessMessage =
    'Request to enable Pipeline has been successfully registered.';

  static resyncObjectSuccessMessage = 'Request to resync Object has been successfully registered.';

  static runNowSuccessMessage = 'Request to run now has been successfully registered.';

  static changeScheduleSuccessMessage = 'Sync frequency updated.';

  static resyncPipelineSuccessMessage = 'Pipeline resync started...';

  static flushExistingStageAreaSuccessMessage = 'Discarded existing edit changes.';
}
